import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";

const AddPartyName = ({ setimgfile, getData }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [company, setCompany] = useState([]);
  const [material, setMaterial] = useState([]);
  const [rowAddData, setRowAddData] = useState({
    party_name: "",
    company_id: "",
  });
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [selectedMaterialId, setSelectedMaterialId] = useState("");
  // console.log(selectedMaterialId)

  function resetFileds() {
    setRowAddData({
      party_name: "",
      company_id: "",
    });
    setSelectedCompanyId("");
    setSelectedMaterialId("");
  }

  const handleCompanyChange = (e) => {
    setSelectedCompanyId(e.target.value);
  };
  const handleMaterialChange = (e) => {
    setSelectedMaterialId(e.target.value);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const { party_name } = rowAddData;
   
    let BASE_URL = SERVER_URL + `/api/party/party-name/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        party_name,
        company_id: selectedCompanyId,
        material_name_id: selectedMaterialId,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      resetFileds();
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setCompany(result.data);
  };

  useEffect(() => {
    getCompany();
  }, []);

  const getMaterial = async () => {
    const BASE_URL =
      SERVER_URL + `/api/raw-mat-name/all-material-names/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setMaterial(result.data);
  };

  useEffect(() => {
    getMaterial();
  }, []);

  return (
    <>
      <div
        className="modal custom-modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Add Party Name
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFileds}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Add Party Name</h4> */}
                    <form
                      className="form-sample"
                      onSubmit={handleAddDataSubmit}
                    >
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="company_name">Company Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleCompanyChange}
                              value={selectedCompanyId}
                              required
                              id="company_name"
                            >
                              <option value="">Select Company Name</option>
                              {company &&
                                company.length > 0 &&
                                company?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.company_name}, ${item.location}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="material_name">Material Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleMaterialChange}
                              value={selectedMaterialId}
                              required
                              id="material_name"
                            >
                              <option value="">Select Material</option>
                              {material &&
                                material?.length > 0 &&
                                material?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.material_name}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="party_name">Party Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="party_name"
                              id="party_name"
                              placeholder="Party Name"
                              onChange={handleChange}
                              value={rowAddData.party_name}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddPartyName;
